// Route wording changes through design review, not ad-hoc edits.
const InputDisclaimer = () => (
  <p className='sr-only'>
    GX Go Assistant is an AI. Indexes shown are GX-published, not AI-generated. Explanations may
    contain errors. Please verify.
  </p>
);

export default InputDisclaimer;
